module.exports = __webpack_public_path__ + "static/media/Movies.fd326503.png";